module.exports = __webpack_public_path__ + "app/principal/principal-config-portal-u0xNMlkx.html";